"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ViewWindow_vue_1 = __importDefault(require("./ViewWindow.vue"));
var TopMenu_vue_1 = __importDefault(require("./TheDistricts/TopMenu.vue"));
var DistrictsTable_vue_1 = __importDefault(require("./TheDistricts/DistrictsTable.vue"));
var VPagination_vue_1 = __importDefault(require("./scraps/VPagination.vue"));
var VAlert_vue_1 = __importDefault(require("./scraps/VAlert.vue"));
var vue_class_component_1 = __importStar(require("vue-class-component"));
var DistrictsMixin_1 = __importDefault(require("../mixins/request/DistrictsMixin"));
var event_bus_1 = require("../event-bus");
var TheDistricts = /** @class */ (function (_super) {
    __extends(TheDistricts, _super);
    function TheDistricts() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "the-districts";
        return _this;
    }
    TheDistricts.prototype.created = function () {
        event_bus_1.EventBus.$on(event_bus_1.events.common.search.phrase, this.onSearchPhraseInput)
            .$on(event_bus_1.events.common.search.hit, this.requestDistrictsFirstPage);
        this.requestDistricts();
    };
    TheDistricts.prototype.beforeDestroy = function () {
        event_bus_1.EventBus.$off(event_bus_1.events.common.search.phrase, this.onSearchPhraseInput)
            .$off(event_bus_1.events.common.search.hit, this.requestDistrictsFirstPage);
    };
    TheDistricts = __decorate([
        vue_class_component_1.default({ components: {
                ViewWindow: ViewWindow_vue_1.default,
                TopMenu: TopMenu_vue_1.default,
                DistrictsTable: DistrictsTable_vue_1.default,
                VPagination: VPagination_vue_1.default,
                VAlert: VAlert_vue_1.default
            } })
    ], TheDistricts);
    return TheDistricts;
}(vue_class_component_1.mixins(DistrictsMixin_1.default)));
exports.default = TheDistricts;
